import PropTypes from "prop-types";
import { Button } from "components/Button";
import { useNavigation } from "utils/navigate";
import { updateIsLoggedIn } from "features/Auth/slice/thunk";
import { useDispatch } from "react-redux";

export const AuthButtons = ({ className }) => {
  const dispatch = useDispatch();
  const { navigateToV2Signup, navigateToV2Signin } = useNavigation();

  const handleSignin = () => {
    dispatch(updateIsLoggedIn());
    navigateToV2Signin();
  };

  return (
    <div className={className}>
      <Button variant="secondary" size="small" onClick={handleSignin}>
        Sign In
      </Button>
      <Button variant="primary" size="small" onClick={navigateToV2Signup}>
        Sign Up
      </Button>
    </div>
  );
};

AuthButtons.propTypes = {
  className: PropTypes.string,
};
